export const FormNotification = ({ state, onClick }) => {
    switch(state) {
        case null:
            return <div className='h-8 w-fit whitespace-nowrap mx-auto mb-4 mt-1 pl-2'></div>
        case 'loading':
            return (
                <div className="flex items-center w-fit whitespace-nowrap h-8 mx-auto mb-4 mt-1 pl-2 outline outline-1 outline-blue-800">
                    <svg aria-hidden='true' className="animate-spin h-4 w-4 m-1" fill="none" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                        <path className='fill-primary' d="M12,1A11,11,0,1,0,23,12,11,11,0,0,0,12,1Zm0,19a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z" opacity=".25"/>
                        <path className='fill-contrast' d="M10.14,1.16a11,11,0,0,0-9,8.92A1.59,1.59,0,0,0,2.46,12,1.52,1.52,0,0,0,4.11,10.7a8,8,0,0,1,6.66-6.61A1.42,1.42,0,0,0,12,2.69h0A1.57,1.57,0,0,0,10.14,1.16Z"/>
                    </svg>
                    <div className='flex-1'>Sending...</div>
                    <div className='flex-grow-0 p-2 hover:cursor-pointer' onClick={onClick}>x</div>
                </div>
            )
        case 'success':
            return (
                <div className="flex items-center w-fit whitespace-nowrap h-8 mx-auto mb-4 mt-1 pl-2 outline outline-1 outline-green-900">                    
                    <div className='flex-1'>✅ Form Submitted!</div>
                    <div className='flex-grow-0 p-2 hover:cursor-pointer' onClick={onClick}>x</div>
                </div>
            )
        case 'failure':
            return (
                <div className="flex items-center w-fit whitespace-nowrap h-8 mx-auto mb-4 mt-1 pl-2 outline outline-1 outline-red-800">
                    <div className='flex-1'>❌ Unable to submit form. Please try again!</div>
                    <div className='flex-grow-0 p-2 hover:cursor-pointer' onClick={onClick}>x</div>
                </div>
            )
    }
}